module.exports = __webpack_public_path__ + "media/music/piano_chords_7-6adc1ba1.mp3";